import React from "react";
import GuestLayout from "../../Components/Layouts/GuestLayout";
import Logo from "../../assets/logo_white_transprent.png";

const Header = (props) => (
  <div
    style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
  >
    <img style={{ width: 150, height: 150, marginTop: 50 }} src={Logo}></img>
    <span
      style={{
        fontWeight: 700,
        textAlign: "center",
        color: "#284F68",
        fontSize: 34,
        lineHeight: 1,
        marginTop: 25,
      }}
    >
      Excise, Taxation & Narcotics <br /> Control Department
    </span>
    <span
      style={{
        marginTop: 10,
        marginBottom: 20,
        fontWeight: 700,
        textAlign: "center",
        color: "grey",
        fontSize: 20,
        lineHeight: 1,
      }}
    >
      Highway Immovable Property Tax <br /> (HIPT)
    </span>
  </div>
);

export default Header;
